<template>
  <div class="authWrapper new-login-wrapper rest-password-container">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/verify-details">
              <h6 class="login-highlight">Back</h6></router-link
            >
            <div class="rep-icon-login">
              <img
                src="../../assets/images/member-login.svg"
                alt="image-fluid"
              />
            </div>
            <h4 class="login-title mb-2">Register to Member Dashboard</h4>
            <div class="auth-form pt-1 pb-3">
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(changePassword)">
                  <b-form-group label="Email" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      type="text"
                      required
                      v-model="memberemail"
                      placeholder="Enter your email"
                      readonly
                    ></b-form-input>
                    <div class="error_message" v-if="formErrorFlag == true">
                      {{ formErrors["email"] }}
                    </div>
                  </b-form-group>
                  <ValidationProvider
                    rules="required"
                    name="New Password"
                    vid="newpassword"
                  >
                    <b-form-group
                      label="New Password"
                      label-for="input-1"
                      slot-scope="{ valid, errors }"
                      class="mb-0"
                    >
                      <div
                        class="changeForm-group errorIcon_eye position-relative"
                      >
                        <b-form-input
                          class="no-bg-icon"
                          id="input-1"
                          :type="newPasswordType"
                          v-model="newpassword"
                          :state="
                            errors[0] || formErrorFlag
                              ? false
                              : valid
                              ? true
                              : null
                          "
                          placeholder="Enter your new password"
                          @input="onPasswordInput"
                        ></b-form-input>
                        <eye-form-button
                          id="newpassword"
                          hideOnDefault="false"
                          :value="newpassword"
                          class="rest-toggle-eye-icon"
                          type="text"
                          @toggle="toggleNewPasswordVisibility"
                        ></eye-form-button>
                        <b-form-invalid-feedback>
                          <div v-if="errors[0]">
                            Please enter your new password
                          </div>
                          <div
                            class="error_message"
                            v-if="formErrorFlag == true"
                          >
                            {{ formErrors["error"] }}
                          </div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>

                  <b-form-group label=" " label-for="" class="mb-0">
                    <div>
                      <password-strength-bar
                        @updateScore="setPasswordScore"
                        :password="newpassword"
                      ></password-strength-bar>
                    </div>
                  </b-form-group>

                  <ValidationProvider
                    rules="required|confirmed:newpassword"
                    name="Re-Type New Password"
                  >
                    <b-form-group
                      label="Re-Type New Password"
                      label-for="input-2"
                      slot-scope="{ valid, errors }"
                    >
                      <div
                        class="changeForm-group position-relative"
                        :class="errors[0] || valid ? 'errorIcon_eye' : ''"
                      >
                        <b-form-input
                          class="no-bg-icon"
                          id="input-2"
                          :type="reTypePasswordType"
                          :state="
                            errors[0] || formErrorFlag
                              ? false
                              : valid
                              ? true
                              : null
                          "
                          v-model="confirmpassword"
                          placeholder="Re-Type New Password"
                        ></b-form-input>
                        <eye-form-button
                          id="reTypepassword"
                          hideOnDefault="false"
                          :value="confirmpassword"
                          class="rest-toggle-eye-icon"
                          type="text"
                          @toggle="toggleReTypePasswordVisibility"
                        ></eye-form-button>
                        <b-form-invalid-feedback>
                          <div>
                            Please reenter your new password
                          </div>
                          <div
                            class="error_message"
                            v-if="formErrorFlag == true"
                          >
                            {{ formErrors["error"] }}
                          </div>
                        </b-form-invalid-feedback>
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                  <button   :disabled="verifyLoader" class="submit-btn mt-3 next-btn ml-0" type="submit">
                    <b-spinner v-if="verifyLoader" small></b-spinner>
                    Save Password
                  </button>
                </b-form>
              </ValidationObserver>
            </div>
          
          </div>
        </div>
        <div class="col-lg-5 col-md-5 p-0">
          <Logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logincarsoule from "./Logincarsoule";
import Api from "@/resource/MemberApi";
import { mapGetters } from "vuex";
import helper from "@/resource/Helper";
import PasswordStrengthBar from "./PasswordStrengthBar.vue";
import EyeFormButton from "../../components/form/EyeFormButton.vue";
import { captureScreenshot } from "../../utlis/helper";

export default {
  name: "NewSignUpContinue",
  components: {
    Logincarsoule,
    PasswordStrengthBar,
    EyeFormButton,
  },
  data() {
    return {
      form: {
        userid: "",
        password: "",
        email_otp: "",
        phone_otp: "",
      },
      memberemail: "",
      loader: false,
      newpassword: "",
      confirmpassword: "",
      formErrorFlag: false,
      formErrors: [],
      verifyLoader: false,
      passwordScore: 0,
      newPasswordType: "password",
      isNewPasswordVisible: true,
      reTypePasswordType: "password",
      isReNewPasswordVisible: true,
    };
  },
  methods: {
    setData() {
      this.memberemail = this.$store.state.memberEmail;
      this.form.userid = this.$store.state.memberId;
      this.form.email_otp = this.$store.state.emailOtp;
      this.form.phone_otp = this.$store.state.phoneOtp;
      if (!this.form.email_otp || !this.form.phone_otp) {
        this.$router.push({ name: "SignUpOtp" });
      }
    },

    toggleNewPasswordVisibility() {
      this.isNewPasswordVisible = !this.isNewPasswordVisible;
      this.newPasswordType = this.isNewPasswordVisible ? "text" : "password";
    },
    toggleReTypePasswordVisibility() {
      this.isReNewPasswordVisible = !this.isReNewPasswordVisible;
      this.reTypePasswordType = this.isReNewPasswordVisible
        ? "text"
        : "password";
    },
    async changePassword() {
      
      const screenshot = await captureScreenshot();
        if (!screenshot) {
          throw new Error('Screenshot capture failed');
        }
      
      if (this.passwordScore < 60) {
        this.formErrorFlag = true;
        this.formErrors["error"] = "Please use strong password.";
        return;
      }
      if (helper.validatePassword(this.newpassword) == false) {
        this.formErrorFlag = true;
        this.formErrors["error"] =
          "Password should be 8 characters long and contain at least 1 uppercase,1 lowercase, number & special character.";
        return;
      }
      let app = this;
      app.formErrorFlag = false;

      app.verifyLoader = true;
      const url = "v3/auth/sign-up-member";
      this.form.password = this.newpassword;
      let postData = { ...this.form, screenshot };
      let loader =  this.$loading.show();
      Api
        .post(url, postData, {
          headers: {
            'X-App-Source': 'web'
          }
        })
        .then(function (response) {
          if (response.data.status == "success") {
            helper.infoMessage(
              app,
              response.data.status,
              response.data.message
            );
            app.$router.push({
              name: "Login",
            });
          }
        })
        .catch(function (error) {
          if (error.response.data.status == "error") {
            app.formErrorFlag = true;
            app.formErrors["error"] = error.response.data.message;
          }
          app.verifyLoader = false;
        })
        .finally(() => {
          app.verifyLoader = false;
          loader.hide();
        });
    },
    setPasswordScore(score) {
      this.passwordScore = score;
    },
    onPasswordInput(value) {
      if (value && value.length > 3) {
        this.formErrorFlag = false;
      }
      this.resetErrorMsg();
    },
    resetErrorMsg() {
      let app = this;
      if (app.formErrorFlag) {
        app.formErrorFlag = false;
        app.formErrors["error"] = "";
      }
    },
  },
  computed: {
    ...mapGetters({
      deviceId: "deviceId",
      email: "memberEmail",
      otp: "OTPCode",
    }),
  },
  created() {
    this.setData();
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}

.rest-password-container .invalid-feedback {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.rest-password-container .error-message {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}
</style>

<style scoped>
.no-bg-icon {
  background: none !important;
}

.rest-toggle-eye-icon {
  position: absolute;
  top: 5px;
  right: 8px;
  cursor: pointer;
}
</style>
